<section class="mat-typography mat-body mat-app-background">
  <h3>{{firstName}} {{lastName}}</h3>
  <p>
    {{prospect.address1}}<br/>
    {{prospect.city}}, {{prospect.state}}<br/>
    {{prospect.zipCode}}
  </p>

  <p><strong>{{prospect.status.description}}</strong></p>
  @if (showPaymentInfo) {
    <div>
      <p [innerHTML]="exchangeStatusNextSteps"></p>
    </div>
  }

  @if (prospect.status.id) {
    <div class="button-container">
      <!-- <button mat-raised-button color="primary" *ngIf="buttonVisibility.editInfo" class="edit-info" (click)="goToEditInfo()">Edit Info</button> -->
      @if (buttonVisibility.goToEligibilityStatus) {
        <button mat-raised-button color="primary" [disabled]="disableButtons" class="view-results" (click)="goToViewResults(prospect.prospectId)">View Results</button>
      }
      @if (buttonVisibility.expire) {
        <button mat-raised-button color="primary" [disabled]="disableButtons" class="expire" (click)="expireApp(prospect.prospectId)">Expire</button>
      }
      @if (buttonVisibility.moreInfo) {
        <button mat-raised-button color="primary" [disabled]="disableButtons" class="more-info" (click)="showMoreInfo()">More Info</button>
      }
      @if (buttonVisibility.goToMarketplace) {
        <button mat-raised-button color="primary" [disabled]="disableButtons" class="go-to-marketplace" (click)="goToMarketplace()">Go To Marketplace</button>
      }
      @if (buttonVisibility.makePayment) {
        <button mat-raised-button color="primary" [disabled]="disableButtons" class="go-to-payment" (click)="goToPaymentFlow(prospect.prospectId)">Go To Marketplace</button>
      }
    </div>
  }
</section>
